import { createFileRoute } from "@tanstack/react-router";
import { NotasFiscaisEntradaPage } from "@/paginas/pg_empresa/empresa-notas-fiscais-entrada";

export const Route = createFileRoute("/_authenticated/empresa-notas-fiscais-entrada")({
  head: () => ({
    meta: [
      { title: "Notas fiscais de entrada — Milky Moo Palmares" },
      {
        name: "description",
        content: "Cadastro e consulta das notas fiscais de entrada e seus itens.",
      },
      { property: "og:title", content: "Notas fiscais de entrada — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Cadastro e consulta das notas fiscais de entrada e seus itens.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: NotasFiscaisEntradaPage,
});
